import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { getParameter } from "@/service/parameter.service";
import { getAverageEstimations, getValidation } from "@/service/estimation.service";
import { Estimation, ValidationFilter_2 } from "@/types/estimation.type";
import { Filter } from "@/types/filter.type";
import { useRoute } from "vue-router";
import moment from "moment";

import { i18n } from "@/plugins/i18n.plugin";

export default /*#__PURE__*/_defineComponent({
  props: {
    selectedValue: null,
    dataClient: null,
    csvData: null,
    nameParameter: null,
    selectedTimeFrom: null,
    selectedTimeTo: null
  },
  setup(__props: any) {

const props = __props as {
  selectedValue: string;
  dataClient: Array<{ date: string; value: string }>;
  csvData: string;
  nameParameter: string;
  selectedTimeFrom: string;
  selectedTimeTo: string;
}

const { t } = useI18n();

const startDate = ref("");
const endDate = ref("");
const route = useRoute();

const currentPage = ref(1);
const pageSize = ref(10);
const total = computed(() => props.dataClient.length);

const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return enhancedData.value.slice(start, end);
});

const handleCurrentChange = (page: number) => {
  currentPage.value = page;
};

const changePaginationSize = (size: number) => {
  pageSize.value = size;
  currentPage.value = 1;
};

const enhancedData = ref<Array<{ date: string; value: string; ourEstimation?: string }>>([]);

const loadCsv = async () => {
  try {
    const rows = props.csvData.split("\n").map((row: string) => row.split(";"));

    const filteredRows = rows
      .slice(1)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .filter((row: any[]) => row[0].trim() && row[1].trim() && row[1].trim() != "-");

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dates = filteredRows.map((row: any[]) => row[0]);

    startDate.value = dates[0];
    endDate.value = dates[dates.length - 1];

    const filter: Filter = {
      fields: {
        "parameter.name": {
          operator: "equal",
          value: props.nameParameter.replace("\r", ""),
        },
      },
    };

    let parameter1 = (await getParameter(undefined, undefined, filter))?.data;
    if (!parameter1 || parameter1.length === 0) {
      // eslint-disable-next-line no-console
      console.error("No se encontró el parámetro");
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let dataUpload = filteredRows.map((row: any[]) => ({
      dateTime: convertDateString(row[0].trim()),
      value: row[1].replace("\r", "").replace(",", ".").trim(),
      magnitude: "",
      origin: "",
      unit: "",
      parameter: parameter1[0],
    }));

    const validationFilter = {
      samplingPointId: Number(route.params.samplingPoint),
      parameterId: Number(parameter1[0].id),
      date: [new Date(parseDate(startDate.value)), new Date(parseDate(endDate.value))],
    } as unknown as ValidationFilter_2;

    let estimation_history: Estimation[] = [];
    if (props.selectedValue === "Muestras integradas") {
      estimation_history = await getAverageEstimations(
        validationFilter,
        formatTime(props.selectedTimeFrom ? props.selectedTimeFrom : "00:00"),
        formatTime(props.selectedTimeTo ? props.selectedTimeTo : "23:59")
      );
    }

    const validateEstimations = await getValidation(
      undefined,
      undefined,
      validationFilter,
      dataUpload
    );

    const validationMap = new Map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validateEstimations.data.map((element: { estimation: any; dateTime: any }) => [
        element.dateTime,
        element.estimation,
      ])
    );

    enhancedData.value = props.dataClient
      .filter((item) => item.date)
      .map((item) => {
        const dateKey = convertDateString(item.date);
        let ourEstimation = validationMap.get(dateKey) ?? "-";

        if (props.selectedValue === "Muestras integradas") {
          const estimationItem = estimation_history.find(
            (estimation) => estimation.dateTime?.toString().slice(0, 10) === dateKey.slice(0, 10)
          );
          if (estimationItem) {
            ourEstimation = estimationItem.value;
          }
        }
        return {
          ...item,
          ourEstimation,
        };
      });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error cargar CSV o estimaciones:", error);
  }
};

const parseDate = (dateString: string) => {
  const [day, month, year, ...time] = dateString.split(/[/ :]/);
  if (time.length === 0) {
    return new Date(Number(year), Number(month) - 1, Number(day)).getTime();
  } else {
    const [hour, minute, second = 0] = time.map(Number);
    return new Date(Number(year), Number(month) - 1, Number(day), hour, minute, second).getTime();
  }
};

const convertDateString = (dateString: string | undefined) => {
  const date = moment(dateString, "DD/MM/YYYY HH:mm:ss");
  return date.toISOString();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function formatNumber(value: any) {
  if (!value || !Number(value) || value === "-") {
    if (Number(value.replace(",", "."))) {
      // return i18n.global.n(Number(value.replace(",", ".")), "fixed");
      return Number(value.replace(",", "."));
    } else {
      return "-";
    }
  } else {
    return i18n.global.n(Number(value), "default");
    // return Number(value);
  }
}

const formatTime = (dateString: string): string => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "00:00";
  }

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes}`;
};

onMounted(async () => {
  await loadCsv();
});

watch(
  () => props.nameParameter,
  async (newVal, oldVal) => {
    if (newVal !== oldVal) {
      await loadCsv();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: _unref(paginatedData),
      height: "375"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "date",
          label: _unref(t)('label.date'),
          width: "200px",
          align: "center",
          "header-align": "center"
        }, null, 8, ["label"]),
        (props.selectedValue != 'Retornos' && props.selectedValue != 'Vertidos')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "value",
              label: _unref(t)('label.refLab'),
              width: "300px",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(formatNumber(scope.row.value)), 1)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (props.selectedValue == 'Validación' || props.selectedValue == 'Muestras integradas')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "ourEstimation",
              label: _unref(t)('label.ourEstimations'),
              width: "300px",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(formatNumber(scope.row.ourEstimation)), 1)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (props.selectedValue == 'Retornos' || props.selectedValue == 'Vertidos')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "value",
              label: _unref(t)('label.values'),
              width: "300px",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(formatNumber(scope.row.value)), 1)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (props.selectedValue == 'Retornos' || props.selectedValue == 'Vertidos')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "ourEstimation",
              label: `${props.nameParameter}`,
              width: "300px",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(formatNumber(scope.row.ourEstimation)), 1)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      layout: "total, sizes, prev, pager, next, jumper",
      currentPage: currentPage.value,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
      "page-sizes": [10, 20, 50, 100],
      onSizeChange: changePaginationSize,
      onCurrentChange: handleCurrentChange,
      "page-size": pageSize.value,
      total: _unref(total)
    }, null, 8, ["currentPage", "page-size", "total"])
  ], 64))
}
}

})